import { render, staticRenderFns } from "./IpoMakeOrder.vue?vue&type=template&id=4bb9c054"
import script from "./IpoMakeOrder.vue?vue&type=script&lang=js"
export * from "./IpoMakeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports